import { defineStore } from "pinia";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

export const useAppFlavorStore = defineStore("appFlavor", {
  state: () => ({
    flavor: "web", // Default assumes web browser
    isNative: false,
    initialized: false,
  }),
  actions: {
    async initFlavor() {
      if (this.initialized) return;

      this.isNative = Capacitor.isNativePlatform();

      if (this.isNative) {
        try {
          const info = await App.getInfo();
          // Assume package name is like "de.praxissecondhand.app",
          // "de.praxissecondhand.sps", "de.praxissecondhand.zeiterfassung"
          if (info.id.endsWith(".sps") || info.id.includes("sps")) {
            this.flavor = "sps";
          } else if (
            info.id.endsWith(".zeiterfassung") ||
            info.id.includes("zeiterfassung")
          ) {
            this.flavor = "zeiterfassung";
          } else {
            this.flavor = "praxis"; // O id termina em .app para o cliente Praxis
          }
        } catch (error) {
          console.error("Erro ao obter App Info via Capacitor", error);
          this.flavor = "praxis"; // Fallback seguro
        }
      } else {
        // 🌐 Detecção de flavor para navegador web/PWA via URL de entrada
        const path = window.location.pathname;
        if (path.startsWith("/app/zeiterfassung")) {
          this.flavor = "zeiterfassung";
        } else if (path.startsWith("/app")) {
          this.flavor = "sps";
        } else {
          this.flavor = "praxis"; // Vitrine
        }
      }

      this.initialized = true;
    },
  },
});
